import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="bg-[#FBF8EF] min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <Loader2 size={24} strokeWidth={1.2} className="animate-spin text-[#5C4033]" />
      </main>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  }
  return children;
}
